import { ColorPickerIcon, TooltipIcon } from '@/utils/helpers/icons.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledQuillToolbar = styled.div`
  &#quill-toolbar {
    margin-top: var(--xsmall-padding);
    border-radius: 9px;
    border: 1px solid var(--gray-dark);
    background: var(--white-main);
    position: sticky;
    top: 0;
    z-index: 99999;
    margin-bottom: 36px !important;

    svg path,
    svg line {
      stroke-width: 1px;
    }

    button,
    .ql-color {
      border-radius: var(--xxxsmall-border-radius);
      background: var(--beige-main);
      margin-right: 5px;
    }

    .ql-formats {
      margin: var(--xxxsmall-padding);
      padding: var(--xxxsmall-padding);
      display: inline-flex;
      align-items: center;
      flex-wrap: nowrap;

      &:not(:last-child) {
        border-right: 1px solid var(--gray-moderate);
      }
    }
  }

  #custom-color-input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  #custom-tooltip-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    white-space: nowrap;
    transition: width 0.3s ease, padding 0.3s ease;
    width: auto;
    min-width: auto;

    svg {
      flex-shrink: 0;
      display: inline-block;
    }

    .tooltip-text {
      display: inline-block;
      opacity: 0;
      max-width: 0;
      margin-left: 0;
      overflow: hidden;
      transition: opacity 0.3s ease 0.1s, max-width 0.5s ease,
        margin-left 0.3s ease;
      white-space: nowrap;
      pointer-events: none;
      color: var(--black-main);
      font-size: var(--xsmall-font-size);
      font-weight: 500;
    }

    &:hover {
      padding-left: var(--xxsmall-padding);
      padding-right: var(--xxsmall-padding);

      .tooltip-text {
        opacity: 1;
        max-width: 200px;
        margin-left: var(--xxsmall-padding);
      }
    }
  }

  .ql-formats.relative {
    gap: 0;
  }
`;

type SlideEditorQuillToolbarProps = {
  className?: string;
};

export const SlideEditorQuillToolbar: React.FC<
  SlideEditorQuillToolbarProps
> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <StyledQuillToolbar id="quill-toolbar" className={className}>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-list" value="bullet" />
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="check" />
        <button className="ql-link" />
      </span>
      <span className="ql-formats relative">
        <button id="custom-tooltip-btn" type="button" title="Add tooltip">
          <TooltipIcon />
          <span className="tooltip-text">{t('content.addTooltip')}</span>
        </button>
        <button id="custom-color-btn" type="button">
          <ColorPickerIcon />
        </button>
        <input type="color" id="custom-color-input" />
      </span>
    </StyledQuillToolbar>
  );
};
